export default __webpack_public_path__ + "42a8668721dad2598c32097c9c8d533c.jpg";